import { SNOWPLOW_SCHEMAS } from '../schemas';

import type { Context, ContextParams } from '../types';

// The artifact entities every Intel Digest 2.0 event attaches
// (klue-snowplow #218), following the same pattern slack-app already uses:
// always the issue, plus a second `artifact` entity for the story whenever
// its id is known — including a failed addition where stak still returned
// one. Snowplow allows several instances of one entity schema on an event.
//
// Both are `artifact/1-0-0` and nothing on the event says which is which;
// downstream tells them apart through `artifact_type` on the stak
// `block_artifacts` sync (`news_rollup` vs `news_item`). One pattern across
// channels is worth more than a digest-only way of naming the pair.
export function digestArtifactContexts({
  eventData,
}: ContextParams = {}): Context[] {
  const contexts: Context[] = [];
  if (eventData?.artifact) {
    contexts.push({
      schema: SNOWPLOW_SCHEMAS.artifact,
      data: eventData.artifact,
    });
  }
  if (eventData?.story) {
    contexts.push({ schema: SNOWPLOW_SCHEMAS.artifact, data: eventData.story });
  }
  return contexts;
}
